import { useApiQuery } from 'theSource/utils';
import {
  DecisionIQSurveyResponseDto,
  DECISION_IQ_SURVEY_QUERY_KEY,
} from './utils';
import { useConfigurationQuery } from 'theSource/queries';

export interface DecisionIQSurveyQueryProps {
  orgBenefitId: number;
  enabled?: boolean;
}

export const useDecisionIQSurveyQuery = ({
  orgBenefitId,
  enabled = true,
}: DecisionIQSurveyQueryProps) => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  const {
    data: decisionIQSurveyData,
    isLoading: isLoadingDecisionIQSurveys,
    isFetching: isFetchingDecisionIQSurveys,
  } = useApiQuery<DecisionIQSurveyResponseDto>({
    queryKey: `${DECISION_IQ_SURVEY_QUERY_KEY}_${orgBenefitId}`,
    config: {
      baseURL: `${apiHost}/v1/self_service`,
    },
    endpoint: `/decision_support/${orgBenefitId}`,
    params: {
      life_event_completed: false,
    },
    enabled: enabled,
  });

  return {
    decisionIQSurveyData,
    isLoadingDecisionIQSurveys,
    isFetchingDecisionIQSurveys,
  };
};
